import "./LocationsBanner.scss";
import MainAppLocationIcon from "../icons/MainAppLocationIcon";
import LocationPriceText from "./misc/LocationPriceText";

export default function LocationsBanner() {
  return (
    <section className={"promo-banner locations-banner"}>
      <h3>Locations</h3>
      <LocationPriceText/>
      <div className={"locations"}>
        <div className={"circle a"}><MainAppLocationIcon color="#f64c59"/></div>
        <div className={"circle b"}><MainAppLocationIcon color="#f64c59"/></div>
        <div className={"circle c"}><MainAppLocationIcon color="#f64c59"/></div>
      </div>
    </section>
  );
}
